import { SHStack, SHTypography } from "@components/design-systems";
import { memo } from "react";

export const SummaryAppendix = memo(() => {
  return (
    <SHStack
      width={"100%"}
    >
      <SHStack>
        <SHTypography variant="h1">Appendix</SHTypography>
        <SHTypography variant="body2">
          Summary of platform considerations
        </SHTypography>
      </SHStack>
    </SHStack>
  );
});
